import styled from '@emotion/styled';
import {
  background,
  border,
  color,
  compose,
  display,
  flexbox,
  layout,
  position,
  space,
  typography,
} from 'styled-system';
import { defineWithTheme } from '../../theming';

export const Section = styled('section')(
  defineWithTheme('sections'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    typography
  )
);
